// Internal dependencies
const {
    generateBackgroundAttributes,
    // generateBorderAttributes,
    generateResBoxControlAttributes,
    generateResRangeAttributes,
    generateTypographyAttributes
} = window.faqmateModules;

// constants
import { B_BG } from './constants';

const attributes = {
    title: {
        type: 'string'
    },
    titleTag: {
        type: 'string',
        default: 'h4'
    },
    content: {
        type: 'string'
    },
    sourceType: {
        type: 'string',
        default: 'library'
    },
    icon: {
        type: 'string',
        default: 'arrow-right'
    },
    featuredImage: {
        type: 'object',
        default: null
    },
    showFeaturedImage: {
        type: 'boolean',
        default: false
    },
    // Generator

    //glaobal section

    ...generateBackgroundAttributes({
        controlName: B_BG
    })
};

export default attributes;
